"use client";
import {
  __async
} from "../../../chunk-MMUBH76A.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { CpslButton, CpslIcon, CpslQrCode, CpslSpinner, CpslText } from "@getpara/react-components";
import { CenteredText, InnerStepContainer, QRContainer, StepContainer } from "../common.js";
import { useEffect, useMemo } from "react";
import { useModalStore } from "../../stores/index.js";
import styled from "styled-components";
import { useExternalWallets } from "../../providers/ExternalWalletContext.js";
import { useCopyToClipboard } from "@getpara/react-common";
import { ModalStep } from "../../utils/steps.js";
import { routeMobileExternalWallet } from "../../utils/routeMobileExternalWallet.js";
import { NETWORK_NOT_SUPPORTED_ERROR } from "../../constants/constants.js";
import { WalletType } from "@getpara/web-sdk";
const ChainSwitch = () => {
  const [isCopied, copy] = useCopyToClipboard();
  const externalWalletError = useModalStore((state) => state.externalWalletError);
  const setStep = useModalStore((state) => state.setStep);
  const setStepDirection = useModalStore((state) => state.setStepDirection);
  const { switchChain, wallet, qrUri, chainIdSwitchingTo, walletDisplayHelpers } = useExternalWallets();
  useEffect(() => {
    if ((wallet == null ? void 0 : wallet.type) === WalletType.COSMOS) {
      routeMobileExternalWallet(qrUri);
    }
  }, [qrUri, wallet]);
  useEffect(() => {
    if (!wallet) {
      setStepDirection(-1);
      setStep(ModalStep.ACCOUNT_MAIN);
    }
  }, [wallet]);
  const handleTryAgainClick = () => __async(void 0, null, function* () {
    if (chainIdSwitchingTo) {
      yield switchChain(chainIdSwitchingTo);
    }
  });
  const handleCopy = () => {
    copy(qrUri);
  };
  const Content = useMemo(() => {
    var _a;
    if (!wallet) {
      return null;
    }
    const { isCosmosMobileWallet } = walletDisplayHelpers;
    if (isCosmosMobileWallet) {
      return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(InnerStepContainer, { children: [
        /* @__PURE__ */ jsx(CpslText, { weight: "semiBold", children: "Scan with your mobile device to switch networks" }),
        /* @__PURE__ */ jsx(QRContainer, { children: !qrUri ? /* @__PURE__ */ jsx(CpslSpinner, { size: 100 }) : /* @__PURE__ */ jsx(CpslQrCode, { url: qrUri, imageSrc: wallet.iconUrl }) }),
        /* @__PURE__ */ jsxs(CpslButton, { size: "small", variant: "ghost", onClick: handleCopy, children: [
          /* @__PURE__ */ jsx(CpslIcon, { slot: "start", icon: isCopied ? "check" : "copy" }),
          isCopied ? "Copied" : "Copy Link"
        ] })
      ] }) });
    }
    return /* @__PURE__ */ jsxs(InnerStepContainer, { children: [
      !(externalWalletError == null ? void 0 : externalWalletError.length) ? /* @__PURE__ */ jsx(CenteredText, { color: "contrast", weight: "semiBold", children: `Confirm the request to change networks in your ${wallet.name} wallet.` }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs(ErrorContainer, { children: [
          /* @__PURE__ */ jsx(ErrorIcon, { icon: "alertCircle" }),
          /* @__PURE__ */ jsx(CenteredText, { weight: "semiBold", color: "error", children: externalWalletError[0] })
        ] }),
        externalWalletError[1] && /* @__PURE__ */ jsx(CenteredText, { color: "secondary", weight: "medium", children: externalWalletError[1] })
      ] }),
      ((_a = externalWalletError == null ? void 0 : externalWalletError[0]) == null ? void 0 : _a.toLowerCase()) !== NETWORK_NOT_SUPPORTED_ERROR && /* @__PURE__ */ jsxs(CpslButton, { variant: "secondary", onClick: handleTryAgainClick, children: [
        /* @__PURE__ */ jsx(CpslIcon, { slot: "start", icon: "refresh" }),
        "Try Again"
      ] })
    ] });
  }, [wallet, walletDisplayHelpers, externalWalletError, qrUri]);
  if (!wallet) {
    return null;
  }
  return /* @__PURE__ */ jsx(Container, { children: Content });
};
const Container = styled(StepContainer)`
  flex: 1;
  justify-content: space-between;
`;
const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;
const ErrorIcon = styled(CpslIcon)`
  --height: 16px;
  --width: 16px;
  --icon-color: var(--cpsl-color-text-error);
`;
export {
  ChainSwitch
};
